import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import styles from './styles.module.scss';
import { getJobStageTriggers, TriggersIcon } from '../../TriggersIcon';
import { buildDropDownActions, JobStageDropdown } from './JobStageDropdown';
import { JobDetails } from '../../../../../entities/JobDetails';
import { ApplyAndScheduleModal } from '../ApplyAndScheduleModal';
import { PipelineJobStage } from '../../../../../entities/v1/applicant_tracking/PipelineJobStage';
import { SortingColumn } from '../../../../../utils/sorting';
import { Tooltip } from 'reactstrap';

interface PropTypes {
  jobDetails: JobDetails;
  pipelineJobStage: PipelineJobStage;
  totalApplications: number;
  selfSchedulingLinkOptionsEnabled: boolean;
  sortingColumn: SortingColumn;
}

export function JobStageHeader(props: PropTypes) {
  const ref = useRef(null);
  const jobStageTriggers = getJobStageTriggers(
    props.pipelineJobStage,
    props.jobDetails.triggers,
  );
  const jobStageHasTriggers = jobStageTriggers?.length > 0;

  const [modalOpen, setModalOpen] = useState(false);
  const [isTitleOverflowing, setIsTitleOverflowing] = useState(false);
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const stageTitle = props.pipelineJobStage.jobStage.name;

  const dropDownActions = buildDropDownActions(
    props.jobDetails.id,
    props.pipelineJobStage,
    props.totalApplications,
    setModalOpen,
    props.selfSchedulingLinkOptionsEnabled,
    props.sortingColumn,
  );

  useEffect(() => {
    const el = ref.current;
    if (el === null) return;

    setIsTitleOverflowing(el.offsetWidth < el.scrollWidth);
  }, [stageTitle]);

  return (
    <div className={'d-flex align-items-center border-bottom'}>
      <h4
        className={classNames(
          'p-4',
          'mb-0',
          'text-truncate',
          'text-start',
          'bg-white',
          'fw-bold',
          styles['pipeline-job-stage-header'],
        )}
        ref={ref}
      >
        {stageTitle}
        {isTitleOverflowing && (
          <Tooltip
            target={ref.current}
            isOpen={isTooltipOpen}
            toggle={() => setIsTooltipOpen(!isTooltipOpen)}
            placement='top'
          >
            <div className='text-white'>{stageTitle}</div>
          </Tooltip>
        )}
      </h4>
      <TriggersIcon
        className={classNames(
          { 'me-2h': dropDownActions.length == 0 },
          'ms-auto',
        )}
        pipelineJobStage={props.pipelineJobStage}
        jobStageTriggers={jobStageTriggers}
      />
      <JobStageDropdown
        className={!jobStageHasTriggers && 'ms-auto'}
        jobId={props.jobDetails.id}
        pipelineJobStage={props.pipelineJobStage}
        menuActions={dropDownActions}
      />
      <ApplyAndScheduleModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        job={props.jobDetails}
        pipelineJobStage={props.pipelineJobStage}
      />
    </div>
  );
}
